import { render, staticRenderFns } from "./UiString.vue?vue&type=template&id=1dc8ccfa&scoped=true&"
import script from "./UiString.vue?vue&type=script&lang=ts&"
export * from "./UiString.vue?vue&type=script&lang=ts&"
import style0 from "./UiString.vue?vue&type=style&index=0&id=1dc8ccfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8ccfa",
  null
  
)

export default component.exports